const SETTINGS = {
  perPage: 5,
  sambaUploaderKey: '7199f18f3cf718fe200ab6c469702464'
};

export { SETTINGS };